import { createSelector } from '@reduxjs/toolkit';

import type { UTM_MARKS } from 'constants/utmMarks';
import { UTM_COOKIE_MAP } from 'constants/utmMarks';

import { getUtmMarksFromQueryOrCookie } from 'shared/lib/getUtmMarksFromQueryOrCookie';
import type { SliceStateFromReducer } from 'shared/types';

import type { utmMarksSlice } from 'entities/utmMarks';

export type TUtmMarksState = SliceStateFromReducer<typeof utmMarksSlice>;

export const selectUtmMarks = (state: TUtmMarksState) => {
  return getUtmMarksFromQueryOrCookie(state.utmMarks.query, state.utmMarks.cookie);
};

export const selectTrafficSourceAsUtmURIString = createSelector([selectUtmMarks], (currentMarks) => {
  const utmTagsKeys = Object.keys(currentMarks) as Array<ValuesOf<typeof UTM_MARKS>>;

  return utmTagsKeys.reduce((previous, key) => {
    const utmTagString = `${UTM_COOKIE_MAP[key]}=${currentMarks[key]}`;
    return previous === '' ? utmTagString : `${previous}|${utmTagString}`;
  }, '');
});
